var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2 align-items-stretch"},_vm._l((_vm.cardList),function(card,index){return _c('WeStatsCard',{key:index,attrs:{"card-index":index,"cards":_vm.cardList},on:{"on-refresh":_vm.onRefresh}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }